import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyCategoryStepTranslations = wrapTranslationsSchema({
	name: 'BuyEasyCategoryStepTranslations',
	title: 'Category Step Translations',
	sanityId: 'buyeasy-wizardCategoryStep',
	fields: {
		question: 'What category does your purchase fall under?',
		categories: 'Categories',
		allCategories: 'All Categories',
		preferredCategories: 'Preferred Categories',
		clearAll: 'Clear All Filters',
		apply: 'Apply',
		categoryDescriptions: 'Category Descriptions',
		categoryDescriptionsLink:
			'https://mytakeda.sharepoint.com/:x:/r/sites/Procurement/_layouts/15/Doc.aspx?sourcedoc=%7B675ED8F4-0A99-4B42-B03D-FB60A06854F5%7D&file=GL%20to%20Category%20-%20Mapping.xlsx&action=default&mobileredirect=true',
		searchForCategories: 'Search for categories, CP codes, materials or services',
		of: 'of',
		results: 'results',
		yourSearchFor:
			'Your search for {query} yielded no results.\nWhy not try these suggestions for better search results?',
		useDifferentSearchTerms:
			'Use different search terms like L0 name or code, L2 name, L3 CP Code, Category Name. material or service description',
		bePreciseAndComplete: 'Be precise and complete with your terms for more accurate results',
		usePartOfAKeyword: 'Use part of a keyword to widen your search range',
		doubleCheckForAny: 'Double-check for any typos in your text',
		tryUsing: 'Try using synonyms',
		considerSearchingInAnotherSupported:
			'Consider searching in another supported language like English, Japanese, Spanish, French, Portuguese, German, Polish, Chinese, or Italian',
		alternatively: 'Alternatively, you can',
		startManualPR: 'Start manual PR',
	},
});
